import * as Yup from 'yup';

export default async function determineFieldType(key) {
  if (!key) {
    return 'Null';
  }
  if (key.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i)) {
    return 'Id';
  }
  try {
    await Yup.string().email().validate(key);

    return 'Email';
  }
  catch (e) {
    return 'Name';
  }
}